import { UrbanFeaturesByBoundingQuery } from "@/types/gql/graphql";

export type UrbanFeature = Omit<UrbanFeaturesByBoundingQuery["urbanFeaturesByBounding"][number], "id"> & {
  id?: string;
};

export enum UrbanFeatureModeType {
  View = "view",
  AddTrafficLight = "addTrafficLight",
  EditTrafficLight = "editTrafficLight",
  AddCrosswalk = "addCrosswalk",
  EditCrosswalk = "editCrosswalk",
  AddSpeedBump = "addSpeedBump",
  EditSpeedBump = "editSpeedBump",
}

export type UrbanFeatureModeAttribute<T> = {
  [key in UrbanFeatureModeType]: T;
};

/**
 * Allowed/registered App Modes
 */
export type UrbanFeatureMode<T = unknown> = keyof UrbanFeatureModeAttribute<T>;
